/**
 * Customer-facing age labels. Venpos often says "4-17" next to "Under 3",
 * which makes a 3-year-old look free. Show "over 3–17" instead.
 */
export function clarifyTicketAgeCopy(text) {
  if (text == null || text === '') return text;

  return String(text)
    .replace(/\baged\s*4\s*[–\-]\s*17\b/gi, 'over 3–17')
    .replace(/\b4\s*[–\-]\s*17\b/g, 'over 3–17')
    .replace(/\baged\s*4\s*[–\-]\s*16\b/gi, 'over 3–16')
    .replace(/\b4\s*[–\-]\s*16\b/g, 'over 3–16');
}

export function ticketsNeedChildAgeNote(tickets = []) {
  return tickets.some((ticket) => {
    const text = `${ticket?.name || ''} ${ticket?.description || ''}`.toLowerCase();
    return text.includes('under 3') || /4\s*[-–]\s*17/.test(text);
  });
}
